export default "__VITE_ASSET__DDJ9yBiz__"